import React, { Dispatch, SetStateAction } from 'react';
import config, { Step } from '../config/selection.config';

export function getContentDependingOnStep(
  activeStepId: number,
  setActiveStep: Dispatch<SetStateAction<number>>,
  selectedVoiceId: string,
  setSelectedVoiceId: Dispatch<SetStateAction<string>>
): React.ReactNode {
  const { steps } = config;

  function isStep(step: Step) {
    return step.id === activeStepId;
  }

  const step = steps.find(isStep);

  if (!step)
    return (
      <div style={{ color: 'red', textAlign: 'center' }}>
        Aucun contenu pour cette étape
      </div>
    );

  const { Content } = step;

  return (
    <Content
      setActiveStep={setActiveStep}
      activeStepId={activeStepId}
      selectedVoiceId={selectedVoiceId}
      setSelectedVoiceId={setSelectedVoiceId}
    />
  );
}

export function getToBannerContentDependingOnStep(
  activeStepId: number
): string {
  let content: string = '';

  switch (activeStepId) {
    case 1: {
      content = 'message.voice.topBanner.content.1';
      break;
    }
    case 2: {
      content = 'message.voice.topBanner.content.2';
      break;
    }
    default: {
      content = 'message.voice.topBanner.content.default';
    }
  }

  return content;
}
